export default __webpack_public_path__ + "static/media/bird_dark_male.175717dc.png";